import { Button, getKeyValue } from "@nextui-org/react";
import { Key, useCallback, useState } from "react";
// import ReferralView from "./referrelview";
import {
  EditIcon,
  // ReferralIcon,
} from "@/assets/icons/admin";
import {
  useGetActivityLogs,
  useGetAllBalances,
} from "@/services/admin.service";
import { format } from "date-fns";
import Datatable from "@/components/tables/datatable";
import { getLocalTimeZone, parseDate } from "@internationalized/date";
import CustomDropdown from "../customdropdown";
import { DateRangePicker } from "@/components/ui/daterangepicker";

const fields = [{ label: "Username", value: "userName" }];

const types = [
  {
    label: "All",
    value: "ALL",
  },
  {
    label: "Delete",
    value: "DELETE",
  },
  {
    label: "Update",
    value: "UPDATE",
  },
];

const columns = [
  {
    key: "no",
    label: "No",
  },
  {
    key: "type",
    label: "Type",
  },
  {
    key: "activity",
    label: "Activity",
  },
  {
    key: "admin",
    label: "Admin",
  },
  {
    key: "createdAt",
    label: "Time",
  },
];

export const ActivityLogs = () => {
  const [filter, setFilter] = useState<any>({
    types: "ALL",
    startDate: format(new Date(), "yyyy-MM-dd"),
    endDate: format(new Date(), "yyyy-MM-dd"),
  });

  const query = useGetActivityLogs;

  const renderCell = useCallback((data: any[], item: any, columnKey: Key) => {
    switch (columnKey) {
      case "no":
        return (
          <div className="">
            {data.findIndex(
              (row: any) => (row as any)?.id === (item as any)?.id,
            ) + 1}
          </div>
        );
      case "createdAt":
      case "updatedAt":
        return (
          <div className="w-max">
            <div>
              {format(item?.createdAt || new Date(), "dd/MM/yyyy HH:mm:ss")}
            </div>
          </div>
        );
      case "admin":
        return <div>{item?.user.userName}</div>;
      default:
        return (
          <div className="font-normal">
            {getKeyValue(item, columnKey as string) || "-"}
          </div>
        );
    }
  }, []);

  return (
    <div>
      <div className="font-ubuntu float-left text-center text-sm font-semibold text-white sm:text-lg">
        <p className="hidden sm:block">Activity Logs</p>
      </div>
      <Datatable
        columns={columns}
        renderCell={renderCell}
        query={query}
        defaultRowsPerPage={"100"}
        searchFields={[]}
        hideSearchKey
        customQueryFilter={{
          ...filter,
        }}
        customFilters={[
          <div className="min-w-[150px] sm:w-1/6">
            <CustomDropdown
              placeholder={filter.types}
              value={filter.types || ""}
              onSelect={(e) => {
                const newFilter = { ...filter, type: e?.value || "" };
                setFilter(newFilter);
              }}
              options={types}
            />
          </div>,
          <DateRangePicker
            onChange={(e: any) => {
              const startDate = format(
                e.start.toDate(getLocalTimeZone()),
                "yyyy-MM-dd",
              );
              const endDate = format(
                e.end.toDate(getLocalTimeZone()),
                "yyyy-MM-dd",
              );
              const newFilter = { ...filter, startDate, endDate };
              setFilter(newFilter);
            }}
          />,
        ]}
      />
    </div>
  );
};
